<template>
  <div class="">
    <slide-over-panel
        v-model:show="$data._show"
        @update:show="updateShow($data._show)"
    >


      <template #content>
            <div class="px-4 py-5 sm:px-6 text-lg font-bold">
              Report History Details
            </div>
          <div class="px-4 py-5 sm:px-6">
            <dl class="grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2">
              <div class="sm:col-span-1">
                <dt class="text-sm font-medium text-gray-500">Report Name</dt>
                <dd class="mt-1 text-sm text-gray-900">{{capitalizeFirstLetter(reportHistory.report_template.report_name)}}</dd>
              </div>
              <div class="sm:col-span-1">
                <dt class="text-sm font-medium text-gray-500">Report Group</dt>
                <dd class="mt-1 text-sm text-gray-900">{{ capitalizeFirstLetter(reportHistory.report_group.name)}}</dd>
              </div>
              <div class="sm:col-span-1">
                <dt class="text-sm font-medium text-gray-500">Report Time Frame</dt>
                <dd class="mt-1 text-sm text-gray-900">{{reportHistory.report_start_time_pretty}} to {{reportHistory.report_end_time_pretty}}</dd>
              </div>
              <div class="sm:col-span-1">
                <dt class="text-sm font-medium text-gray-500">Report Execution Type</dt>
                <dd class="mt-1 text-sm text-gray-900">{{ capitalizeFirstLetter(reportHistory.report_type) }}</dd>
              </div>
              <div class="sm:col-span-1">
                <dt class="text-sm font-medium text-gray-500">Report Duration Type</dt>
                <dd class="mt-1 text-sm text-gray-900">{{ capitalizeFirstLetter(reportHistory.report_duration_type)}}</dd>
              </div>
              <div class="sm:col-span-1">
                <dt class="text-sm font-medium text-gray-500">Creation Date</dt>
                <dd class="mt-1 text-sm text-gray-900">{{reportHistory.created_at_pretty}}</dd>
              </div>
            </dl>
          </div>
          <button type="button" class="px-6 inline-block py-0.5 text-base font-semibold leading-7 text-blue-700 hover:text-blue-400"
                  @click="viewReport(reportHistory.cloud_file_path)">View Report</button>
      </template>
    </slide-over-panel>
  </div>
</template>


    <script>

      import axios from "axios"
      import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
      import {iconNamesMixin} from '@/mixins/IconNamesMixin';
      import SlideOverPanel from '@/components/elements/SlideOverPanel';
      import GreenButton from '@/components/elements/green-button';
      import SmallColoredCheck from "@/components/elements/SmallColoredCheck";
      import Select2 from '@/components/elements/select2';
      import ButtonRedPrimary from "@/components/elements/buttons/ButtonRedPrimary";
      import ButtonAjax from "@/components/elements/buttonAjax";
      import NotificationModal from "@/components/elements/NotificationModal";
      import SonicuButton from "@/components/elements/buttons/SonicuButton";

      export default {
        name: "ReportHistoryDetails",
        mixins: [SonicuCoreMixin, iconNamesMixin],
        components: {
          SonicuButton,
          NotificationModal, ButtonAjax, ButtonRedPrimary, SmallColoredCheck, SlideOverPanel, GreenButton, Select2},
        props: {
          show: Boolean,
          reportHistory: Object
        },
        data() {
          return {
            _show: this.show,
            processing: false,
          }
        },
        created() {
        },
        mounted() {
        },
        methods: {
          updateShow(show) {
            this.$data._show = show
            this.$emit('update:show', this.$data._show)
          },
          viewReport(url){
            //return window.location.href = url
            return window.open(url, '_blank');
          },
          capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
      }
      },
        watch: {
          show() {
            this.$data._show = this.show;
          },
        }
      }

    </script>

    <style scoped>

    </style>